import React, {FC, ReactNode} from "react"
import {OverlayTrigger} from "react-bootstrap"

import id from "@irati/utils/id"

import {Overlay as DefaultOverlay} from "./"
import {OverlayProps, OverlayPlacement} from "./Overlay"

interface Props extends OverlayProps {
  tooltipChildren: ReactNode,
  OverlayComponent?: ReactNode,
  id?: string,
  onEntered?: () => void,
  placement?: OverlayProps["placement"],
  delayHide?: number
}

const Tooltip: FC<Props> = ({
  children,
  placement = OverlayPlacement.Right,
  tooltipChildren,
  OverlayComponent = DefaultOverlay,
  onEntered,
  delayHide,
  ...props
}) => {
  const idNamespace = id("Tooltip", props)

  return (
    <OverlayTrigger
      onEntered={onEntered}
      id={id("trigger", idNamespace)}
      placement={placement}
      delayHide={delayHide}
      overlay={<OverlayComponent id={idNamespace}>{tooltipChildren}</OverlayComponent>}>
      {children}
    </OverlayTrigger>
  )
}

export default Tooltip
